import { render, staticRenderFns } from "./RecipeItem.vue?vue&type=template&id=7eefdfc2&"
import script from "./RecipeItem.vue?vue&type=script&lang=js&"
export * from "./RecipeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports